import React from "react";
import BreadCrumb from "../../../Common/BreadCrumb";
import { fullWidth, iconcheckbox } from "../../../Common/data";

const BasicTable = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Basic Table" pageType="Table" />
      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Table Full width
            </h2>
            <div className="overflow-auto">
              <table className="min-w-[640px] w-full">
                <thead>
                  <tr className="ltr:text-left rtl:text-right">
                    <th>#</th>
                    <th>Name</th>
                    <th>Title</th>
                    <th>Role</th>
                  </tr>
                </thead>
                <tbody>
                  {fullWidth.map((item: any) => (
                    <tr className="text-muted" key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.name}</td>
                      <td>{item.title}</td>
                      <td>
                        <span
                          className={`inline-block items-center rounded text-xs justify-center px-1.5 py-0.5 ${item.roleColor}`}
                        >
                          {item.role}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Table Hover
            </h2>
            <div className="overflow-auto">
              <table className="min-w-[640px] w-full table-hover">
                <thead>
                  <tr className="ltr:text-left rtl:text-right">
                    <th>#</th>
                    <th>Name</th>
                    <th>Title</th>
                    <th>Role</th>
                  </tr>
                </thead>
                <tbody>
                  {fullWidth.map((item: any, idx: any) => (
                    <tr className="text-muted" key={idx}>
                      <td>{item.id}</td>
                      <td>{item.name}</td>
                      <td>{item.title}</td>
                      <td>{item.role}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Captions with icon
            </h2>
            <div className="overflow-auto">
              <table className="min-w-[640px] w-full">
                <thead>
                  <tr className="ltr:text-left rtl:text-right">
                    <th>Project Name</th>
                    <th>Assigned to</th>
                    <th>Time Spend</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {iconcheckbox.map((item: any) => (
                    <tr key={item.id}>
                      <td>{item.projectName}</td>
                      <td>
                        <div className="flex items-center -space-x-1.5 rtl:space-x-reverse">
                          {item.assignedTo.map((subItem: any) => (
                            <React.Fragment key={subItem.id}>
                              {subItem.avatar ? (
                                <img
                                  className="object-cover w-6 h-6 overflow-hidden rounded-full ring-2 ring-white dark:ring-darkborder"
                                  src={subItem.avatar}
                                  alt=""
                                />
                              ) : (
                                ""
                              )}
                              {subItem.placeholder ? (
                                <span className="flex items-center justify-center object-cover w-6 h-6 text-xs text-center rounded-full bg-light ring-2 ring-white dark:ring-darkborder dark:text-black">
                                  {subItem.placeholder}
                                </span>
                              ) : (
                                ""
                              )}
                            </React.Fragment>
                          ))}
                        </div>
                      </td>
                      <td>{item.timeSpend}</td>
                      <td className={item.color}>
                        <span className="h-1.5 w-1.5 rounded-full inline-block relative -top-px bg-current ltr:mr-0.5 rtl:ml-0.5"></span>
                        <span>{item.label}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Table with checkbox
            </h2>
            <div className="overflow-auto">
              <table className="min-w-[640px] w-full">
                <thead>
                  <tr className="ltr:text-left rtl:text-right">
                    <th>
                      <input
                        type="checkbox"
                        className="form-checkbox outborder-black dark:outborder-purple"
                      />
                    </th>
                    <th>Project Name</th>
                    <th>Assigned to</th>
                    <th>Time Spend</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {iconcheckbox.map((item: any) => (
                    <tr key={item.id}>
                      <td>
                        <input
                          type="checkbox"
                          className="form-checkbox outborder-black dark:outborder-purple"
                          defaultChecked={item.check}
                        />
                      </td>
                      <td>{item.projectName}</td>
                      <td>
                        <div className="flex items-center -space-x-1.5 rtl:space-x-reverse">
                          {item.assignedTo.map((subItem: any) => (
                            <React.Fragment key={subItem.id}>
                              {subItem.avatar ? (
                                <img
                                  className="object-cover w-6 h-6 overflow-hidden rounded-full ring-2 ring-white dark:ring-darkborder"
                                  src={subItem.avatar}
                                  alt=""
                                />
                              ) : (
                                ""
                              )}
                              {subItem.placeholder ? (
                                <span className="flex items-center justify-center object-cover w-6 h-6 text-xs text-center rounded-full bg-light ring-2 ring-white dark:ring-darkborder dark:text-black">
                                  {subItem.placeholder}
                                </span>
                              ) : (
                                ""
                              )}
                            </React.Fragment>
                          ))}
                        </div>
                      </td>
                      <td>{item.timeSpend}</td>
                      <td className={item.color}>
                        <span className="h-1.5 w-1.5 rounded-full inline-block relative -top-px bg-current ltr:mr-0.5 rtl:ml-0.5"></span>
                        <span>{item.label}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Table Action
            </h2>
            <div className="overflow-auto">
              <table className="min-w-[640px] w-full">
                <thead>
                  <tr className="ltr:text-left rtl:text-right">
                    <th>Project Name</th>
                    <th>Assigned to</th>
                    <th>Time Spend</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {iconcheckbox.map((item: any, index: any) => (
                    <tr key={index}>
                      <td>{item.projectName}</td>
                      <td>
                        <div className="flex items-center -space-x-1.5 rtl:space-x-reverse">
                          {item.assignedTo.map((subItem: any) => (
                            <React.Fragment key={subItem.id}>
                              {subItem.avatar ? (
                                <img
                                  className="object-cover w-6 h-6 overflow-hidden rounded-full ring-2 ring-white dark:ring-darkborder"
                                  src={subItem.avatar}
                                  alt=""
                                />
                              ) : (
                                ""
                              )}
                              {subItem.placeholder ? (
                                <span className="flex items-center justify-center object-cover w-6 h-6 text-xs text-center rounded-full bg-light ring-2 ring-white dark:ring-darkborder dark:text-black">
                                  {subItem.placeholder}
                                </span>
                              ) : (
                                ""
                              )}
                            </React.Fragment>
                          ))}
                        </div>
                      </td>
                      <td>{item.timeSpend}</td>
                      <td className={item.color}>
                        <span className="h-1.5 w-1.5 rounded-full inline-block relative -top-px bg-current ltr:mr-0.5 rtl:ml-0.5"></span>
                        <span>{item.label}</span>
                      </td>
                      <td>
                        <button className="text-black dark:text-white/80">
                          <svg
                            xmlns=" http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            className="inline-block w-5 h-5"
                          >
                            <path
                              fill="currentColor"
                              d="M5 18.89H6.41421L15.7279 9.57629L14.3137 8.16207L5 17.4758V18.89ZM21 20.89H3V16.6474L16.435 3.21233C16.8256 2.8218 17.4587 2.8218 17.8492 3.21233L20.6777 6.04075C21.0682 6.43128 21.0682 7.06444 20.6777 7.45497L9.24264 18.89H21V20.89ZM15.7279 6.74786L17.1421 8.16207L18.5563 6.74786L17.1421 5.33365L15.7279 6.74786Z"
                            ></path>
                          </svg>
                        </button>
                        <button className="text-danger ltr:ml-2 rtl:mr-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            className="inline-block w-5 h-5"
                          >
                            <path
                              fill="currentColor"
                              d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"
                            ></path>
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Table Striped
            </h2>
            <div className="overflow-auto">
              <table className="min-w-[640px] w-full table-striped">
                <thead>
                  <tr className="ltr:text-left rtl:text-right">
                    <th>#</th>
                    <th>Name</th>
                    <th>Title</th>
                    <th>Role</th>
                  </tr>
                </thead>
                <tbody>
                  {fullWidth.map((item: any) => (
                    <tr className="text-muted" key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.name}</td>
                      <td>{item.title}</td>
                      <td>{item.role}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Table Borderless
            </h2>
            <div className="overflow-auto">
              <table className="min-w-[640px] w-full table-borderless">
                <thead>
                  <tr className="ltr:text-left rtl:text-right">
                    <th>#</th>
                    <th>Name</th>
                    <th>Title</th>
                    <th>Role</th>
                  </tr>
                </thead>
                <tbody>
                  {fullWidth.map((item: any) => (
                    <tr className="text-muted" key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.name}</td>
                      <td>{item.title}</td>
                      <td>{item.role}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BasicTable;
